import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { RootLayout } from '@/components/layout'
import { LegacyProjectRedirect } from './LegacyProjectRedirect'
import { ROUTES, ROUTE_PATTERNS } from '@/lib/paths'
import {
  AboutPage,
  AdminPage,
  ContactPage,
  HomePage,
  NotFoundPage,
  ProjectDetailPage,
  ProjectsPage,
  ResearchPage,
  ServicesPage,
} from '@/pages'

/**
 * Route table.
 *
 * Declared as data rather than JSX so the routes can be read at a glance and
 * reused — by a data router, by tests, or to pre-render a sitemap.
 *
 * The trailing redirects preserve the singular paths the original Framer site
 * published (`/service`, `/project/:slug`) so existing links keep working.
 */
export const routes: RouteObject[] = [
  // Outside RootLayout: the admin has its own chrome.
  { path: ROUTES.admin, element: <AdminPage /> },
  {
    path: ROUTES.home,
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: ROUTES.about, element: <AboutPage /> },
      { path: ROUTES.services, element: <ServicesPage /> },
      { path: ROUTES.projects, element: <ProjectsPage /> },
      { path: ROUTE_PATTERNS.project, element: <ProjectDetailPage /> },
      { path: ROUTES.research, element: <ResearchPage /> },
      { path: ROUTES.contact, element: <ContactPage /> },

      { path: '/service', element: <Navigate to={ROUTES.services} replace /> },
      { path: '/blog', element: <Navigate to={ROUTES.research} replace /> },
      { path: '/project', element: <Navigate to={ROUTES.projects} replace /> },
      { path: '/project/:slug', element: <LegacyProjectRedirect /> },

      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
